export default {
	menu: {
		notification: 'notification',
		settings: 'settings',
		logout: 'logout'
	}
}